import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useTemplates } from '@/features/lists/lists.hooks';
import { TemplatesTable } from './templates.table';

export const TemplatesPanel = ({
  params: _params,
  path: _path,
  basePath: _basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const resource = useTemplates();
  return (
    <Panel {...panelProps}>
      <TemplatesTable {...resource} />
    </Panel>
  );
};
